module.exports = __webpack_public_path__ + "img/bgchome.5226a7c3.jpg";